import NumericText from './NumericText'

export default NumericText
